import { RefreshCw, Sparkles } from 'lucide-react';
import { useAppStore } from '../store/useAppStore';

/**
 * A deploy has landed under this tab.
 *
 * Nothing reloads the page on somebody's behalf, and that is the whole design of
 * this: a reload throws away everything a tab is holding that is not on the
 * server — which scenario it has open, what is expanded, what is filtered — and
 * doing that to somebody mid-reorg to deliver a bug fix is a bad trade. So it
 * says the new version is there and lets them pick the moment.
 *
 * Bottom left, out of the way of the change panel on the right and the scenario
 * menu along the top, and it does not dismiss itself: a notice that disappears
 * before it is read is the same as no notice.
 */
export function UpdateNotice() {
  const ready = useAppStore((s) => s.updateReady);

  if (!ready) return null;

  return (
    <div
      role="status"
      className="fixed bottom-4 left-4 z-40 flex max-w-[19rem] items-start gap-2.5 rounded-xl border border-[var(--color-line)] bg-[var(--color-surface)] p-3 shadow-[var(--shadow-panel)]"
    >
      <Sparkles size={15} className="mt-0.5 shrink-0 text-[var(--color-brand)]" aria-hidden />
      <div className="min-w-0">
        <p className="text-[12.5px] font-semibold text-[var(--color-ink)]">A new version is ready</p>
        <p className="mt-0.5 text-[11.5px] leading-snug text-[var(--color-ink-3)]">
          Reload when it suits you. Your plan is saved as you work, so nothing is waiting on this.
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="mt-2 flex items-center gap-1.5 rounded-lg bg-[var(--color-brand-fill)] px-2.5 py-1 text-[12px] font-semibold text-white transition-opacity hover:opacity-90"
        >
          <RefreshCw size={12} />
          Reload
        </button>
      </div>
    </div>
  );
}
